var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCompleted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.148,
    height: 15.897,
    viewBox: "0 0 16.148 15.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-check-circle",
    "data-name": "Icon feather-check-circle",
    transform: "translate(-2.061 -2.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7905",
    "data-name": "Path 7905",
    d: "M17.148,9.418v.651A7.074,7.074,0,1,1,12.953,3.6",
    transform: "translate(0)",
    fill: "none",
    stroke: "#119f58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7906",
    "data-name": "Path 7906",
    d: "M22.7,6l-7.074,7.081L13.5,10.959",
    transform: "translate(-5.548 -1.59)",
    fill: "none",
    stroke: "#119f58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompleted);
export default __webpack_public_path__ + "static/media/icon-completed.8b0367a69470556eeee7abee7241493c.svg";
export { ForwardRef as ReactComponent };